module.exports = __webpack_public_path__ + "images/lab/field-prototypes-1bcee27013fdd45c8b334807fa84c8d2.jpg";